export default class PaymentMethodModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.name = obj.name;
    this.createdAt = obj.createdAt;
    this.updatedAt = obj.updatedAt;
  }
}